// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__hSjhZ","load":"styles_load__9EN_I","pulse":"styles_pulse__BMXc3","spin":"styles_spin__NJ7_J"};